import type { GUID } from "@pdfking/tfunc"

import type { ReceiverAction } from "./ReceiverAction"

export type ReceiverMessage<T> =
  | {
      readonly action: ReceiverAction.START
      readonly request_channel: GUID
      readonly response_channel: GUID
    }
  | {
      readonly action: ReceiverAction.STOP
      readonly channel_id: GUID
      readonly error?: Error
    }
  | {
      readonly action: ReceiverAction.YIELD
      readonly channel_id: GUID
      readonly data: T
    }
